



















































































































































































































































































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import InfoCard from '../InfoCard.vue';
import Tripod from '../productsInfoCards/Tripod.vue'
import EtuiTravelCase from '../productsInfoCards/EtuiTravelCase.vue'
import Charger from '../productsInfoCards/Charger.vue'
import HardenedGlass from '../productsInfoCards/HardenedGlass.vue'
import VocaleSystem from '../productsInfoCards/VocaleSystem.vue'

@Component({
  name: 'InfoSection',
  components: {
    InfoCard,
    Tripod,
    EtuiTravelCase,
    Charger,
    HardenedGlass,
    VocaleSystem
  },
})
export default class InfoSection extends Vue {
  openedInfoCards: number[] = [1];

  handleInfoCardClicked(index: number) {
    if (this.openedInfoCards.includes(index)) {
      this.openedInfoCards = this.openedInfoCards.filter(value => value != index);
    } else {
      this.openedInfoCards.push(index);
    }
  }
}
